export const AUTHOR_BOT = 'bot'
export const AUTHOR_OPERATOR = 'operator'
export const AUTHOR_USER = 'me'
export const AUTHOR_SYSTEM = 'system'
